import { Button, Flex, Stack, Text } from "@chakra-ui/react";
import { Icon } from "@pufflig/prompt-studio-ui";

interface PricingPlanProps {
  header: string;
  price?: string;
  isDisabled?: boolean;
  description: string;
  buttonText: string;
  items: string[];
  isFirst?: boolean;
  isLast?: boolean;
  isPopular?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
  isVertical?: boolean;
  isLoading?: boolean;
}

interface FeatureProps {
  name: string;
}

const Feature = (props: FeatureProps) => {
  const { name } = props;
  return (
    <Flex alignItems="center" gap="0.5rem">
      <Icon name="check" size="sm" />
      <Text textStyle="bodyS">{name}</Text>
    </Flex>
  );
};

export const PricingPlan = (props: PricingPlanProps) => {
  const { isLoading, header, price, description, items, buttonText, onClick, isDisabled, isSelected } = props;
  return (
    <Flex
      border="1px solid"
      bg={isSelected ? "background.accent-gray" : "background.primary"}
      borderColor={isSelected ? "border.accents.blue-dark" : "border.secondary"}
      borderRadius="radius-lg"
      textAlign="left"
      flex="1"
      width="20rem"
      direction="column"
      padding="2rem"
      gap="1.875rem"
    >
      <Stack gap="spacing-md" mb="spacing-lg">
        <Text textStyle="heading/1">{header}</Text>
        <Flex direction="column" height="6rem">
          <Text textStyle="label/L/medium" mb="spacing-lg">
            {price}
          </Text>
          <Text textStyle="body/M/regular" color="foreground.secondary">
            {description}
          </Text>
        </Flex>
      </Stack>
      <Button
        isDisabled={isDisabled}
        onClick={onClick}
        isLoading={isLoading}
        width="100%"
        variant={buttonText == "Downgrade" ? "outline" : "primary"}
      >
        {buttonText}
      </Button>
      <Flex direction="column" gap="1rem">
        <Text textStyle="label/L/medium">What&#39;s included</Text>
        <Stack gap="1">
          {items.map((item, index) => {
            return <Feature key={index} name={item} />;
          })}
        </Stack>
      </Flex>
    </Flex>
  );
};
